import { Button } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import '../../Assets/Styles/Customer/font-size.css'

export default function CustomButtonPolicyInfoCustomer({ title, onClick }) {
    return (
        <Button fullWidth variant="contained" sx={{ backgroundColor: "#162938", ":hover": { backgroundColor: "#c4960c" }, borderRadius: "0px", width: 'fit-content', margin: "0 2%" }}
            endIcon={<ArrowForwardIosIcon />} onClick={onClick}>
            <span className="status-policy-customer">{title}</span>
        </Button>
    )
};
